/* ty-flavor-rescue.js · Triple Y · 01.10.2026
 * «אזל בגרסה הזו, יש בגרסה אחרת», ו«עדכנו אותי» בדף המוצר.
 * מצב א: הצירוף (נפח + צבע) אזל בשני הסניפים בגרסה של הדף, ויש אותו בגרסה אחרת.
 *        קוביות הסניפים מוחלפות בקוביות של הגרסה האחרת, עם תגית, וקישור לדף שלה.
 * מצב ב: הצירוף אזל בכל הגרסאות. טופס שם + טלפון במקום הקוביות.
 * הגרסאות האחיות נגזרות מה-handle ונבדקות ב-/products/<handle>.js. מוצר לא פעיל
 * מחזיר 404 ונעלם, ולכן ניחוש שגוי לעולם לא מוצג.
 */
(function () {
  if (window.__tyFlavorRescue) return;
  window.__tyFlavorRescue = true;

  var RESTOCK_URL = 'https://leads.tripley.co.il/hook/restock';
  var NOTIFY_MODELS = ['iphone-18-pro', 'iphone-18-pro-max'];
  var NOTIFY_SIZES = ['256GB', '512GB', '1TB'];
  var FLAVORS = [
    { id: 'regular', sfx: '', name: 'רגיל', phrase: 'בגרסה הרגילה', the: 'הגרסה הרגילה', desc: 'SIM פיזי + eSIM', short: 'הגרסה הרגילה', link: 'לדף הגרסה הרגילה' },
    { id: 'esim', sfx: '-esim-only', name: 'eSIM בלבד', phrase: 'בגרסת eSIM בלבד', the: 'גרסת eSIM בלבד', desc: 'בלי מקום לכרטיס SIM פיזי', short: 'eSIM', link: 'לדף ה-eSIM' },
    { id: 'official', sfx: '-official', name: 'יבואן רשמי', phrase: 'בגרסת יבואן רשמי', the: 'גרסת יבואן רשמי', desc: 'אחריות יבואן רשמי', short: 'יבואן רשמי', link: 'לדף היבואן הרשמי' }
  ];

  /* השם של «רגיל» תלוי במה שמולו, הכרעת יובל 01.10.2026:
     מול eSIM בלבד: «הגרסה עם SIM פיזי». מול יבואן רשמי: «הייבוא שלנו». */
  function txt(f, other) {
    if (f.id === 'esim') return { name: 'eSIM בלבד', phrase: 'בגרסת eSIM בלבד', the: 'גרסת eSIM בלבד', desc: 'בלי מקום לכרטיס SIM פיזי', link: 'לדף ה-eSIM' };
    if (f.id === 'official') return { name: 'יבואן רשמי', phrase: 'בגרסת היבואן הרשמי', the: 'גרסת היבואן הרשמי', desc: 'אחריות יבואן רשמי', link: 'לדף היבואן הרשמי' };
    if (other && other.id === 'esim') return { name: 'עם SIM פיזי', phrase: 'בגרסה עם SIM פיזי', the: 'הגרסה עם SIM פיזי', desc: 'יש בה מקום לכרטיס SIM פיזי וגם eSIM', link: 'לדף הגרסה עם SIM פיזי' };
    return { name: 'הייבוא שלנו', phrase: 'בגרסת הייבוא שלנו', the: 'גרסת הייבוא שלנו', desc: '', link: 'לדף הייבוא שלנו' };
  }

  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  /* ty-flavor-404a >>> */
  /* tps-09, 14.10.2026: תאום אילת נבדק רק אם גרסת ההוד שלו קיימת, ו-404 נזכר לכל הביקור. */
  var tyMiss = {}; try { tyMiss = JSON.parse(sessionStorage.getItem('tyfr404') || '{}') || {}; } catch (e) { tyMiss = {}; }
  var tyGet = getProduct;
  getProduct = function (handle) {
    if (tyMiss[handle]) return Promise.resolve(null);
    var m = /^(.*)-eilat$/.exec(handle);
    var pre = m ? getProduct(m[1]) : Promise.resolve(true);
    return pre.then(function (hp) {
      if (!hp) return null;
      return tyGet(handle).then(function (p) {
        if (!p) { tyMiss[handle] = 1; try { sessionStorage.setItem('tyfr404', JSON.stringify(tyMiss)); } catch (e) {} }
        return p;
      });
    });
  };
  /* <<< ty-flavor-404a */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) { return '₪' + Math.round(cents / 100).toLocaleString('en-US'); }

  function idx(p, re) { return (p.options || []).findIndex(function (o) { return re.test(o.name || o); }); }
  function comboOf(p, v) {
    var si = idx(p, /נפח|storage/i), ci = idx(p, /צבע|color/i);
    return { size: si >= 0 ? v.options[si] : '', color: ci >= 0 ? v.options[ci] : '' };
  }
  function matchVariants(p, size, color) {
    if (!p) return [];
    var si = idx(p, /נפח|storage/i), ci = idx(p, /צבע|color/i);
    return p.variants.filter(function (v) {
      return (si < 0 || v.options[si] === size) && (color == null || ci < 0 || v.options[ci] === color);
    });
  }
  function pick(p, size, color) {
    var vs = matchVariants(p, size, color);
    if (!vs.length) return null;
    var a = vs.filter(function (v) { return v.available; });
    return { v: a[0] || vs[0], available: !!a.length };
  }

  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function productForm() { return document.querySelector('product-form form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"][id^="product-form"]'); }
  /* הגרסה שהלקוח בחר. 🔴 לא מה ששמרנו בעצמנו: הערכה כותבת את הגרסה החדשה
     לכתובת ולטופס בכל מעבר (product-info.js, updateURL ו-updateVariantInputs).
     הכתובת קודמת. הטופס משמש רק אם הוא אינו מחזיק את הגרסה החלופית שהצבנו בו. */
  var swap = null; // { orig, alt } כשהחלפנו את מזהה הגרסה בטופס
  function currentVariantId(cur) {
    var u = new URL(location.href).searchParams.get('variant');
    if (u && cur && cur.variants.some(function (x) { return String(x.id) === String(u); })) return u;
    var f = productForm(), inp = f && f.querySelector('input[name="id"]');
    if (inp && inp.value) {
      if (swap && String(inp.value) === String(swap.alt)) return swap.orig;
      return inp.value;
    }
    return u;
  }

  var CHEV = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
  var XICON = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var BELL = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>';

  function formHtml(opts) {
    return '<form class="tyfr__form" novalidate>' +
      '<p class="tyfr__ft">' + opts.title + '</p>' +
      '<p class="tyfr__fs">' + opts.sub + '</p>' +
      '<div class="tyfr__row">' +
        '<input type="text" name="name" autocomplete="given-name" placeholder="שם" aria-label="שם" required>' +
        '<input type="tel" name="phone" autocomplete="tel" inputmode="tel" placeholder="טלפון" aria-label="טלפון" required>' +
      '</div>' +
      '<input type="text" name="website" tabindex="-1" autocomplete="off" class="tyfr__hp" aria-hidden="true">' +
      (opts.anyColor ? '<label class="tyfr__ck"><input type="checkbox" name="any" checked> ' + opts.anyColor + '</label>' : '') +
      '<button type="submit" class="tyfr__btn">עדכנו אותי</button>' +
      '<p class="tyfr__err" hidden></p>' +
      '<p class="tyfr__ok" hidden>נרשמת. נעדכן אותך כשיחזור למלאי.</p>' +
    '</form>';
  }

  function wireForm(form, ctx) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = form.querySelector('.tyfr__err'), ok = form.querySelector('.tyfr__ok'), btn = form.querySelector('.tyfr__btn');
      var name = form.name.value.trim(), phone = form.phone.value.replace(/\D/g, '');
      err.hidden = true;
      if (!name) { err.textContent = 'נא למלא שם.'; err.hidden = false; return; }
      if (!/^05\d{8}$/.test(phone)) { err.textContent = 'מספר הטלפון לא תקין. צריך מספר נייד.'; err.hidden = false; return; }
      btn.disabled = true;
      var payload = {
        name: name, phone: phone, website: form.website.value,
        product_id: String(ctx.product.id), variant_id: String(ctx.variant.id),
        product_title: ctx.product.title, variant_title: ctx.variant.title,
        notify_all_variants: !!(form.any && form.any.checked),
        handle: ctx.product.handle, source: 'pdp-flavor', page: location.pathname,
        shop: (window.Shopify && window.Shopify.shop) || location.hostname,
        timestamp: new Date().toISOString()
      };
      fetch(RESTOCK_URL, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (o) { if (!r.ok || !o.ok) throw new Error((o && o.why) || ('HTTP ' + r.status)); }); })
        .then(function () {
          form.querySelectorAll('.tyfr__row, .tyfr__ck, .tyfr__btn, .tyfr__fs').forEach(function (el) { el.hidden = true; });
          ok.hidden = false;
        })
        .catch(function (x) {
          var why = String((x && x.message) || '');
          err.textContent = why === 'phone' ? 'מספר הטלפון לא תקין. צריך מספר נייד.'
            : why === 'name' ? 'נא למלא שם.'
            : why === 'busy' ? 'יותר מדי ניסיונות. נסו שוב בעוד כמה דקות.'
            : 'אירעה שגיאה. נסו שוב.';
          err.hidden = false; btn.disabled = false;
        });
    });
  }

  /* ---------- כפתור הקנייה במצב א ---------- */
  var buyMode = null; // { kind: 'hod', vid } | { kind: 'eilat', url }
  /* הכפתור הראשי, והכפתור בפס הדביק במחשב (‎.sticky-cta, גולל לטופס). */
  function addButtons() { return Array.prototype.slice.call(document.querySelectorAll('button[name="add"], .sticky-cta button[data-anchor]')); }
  function setBuy(mode) {
    buyMode = mode;
    var f = productForm(), inp = f && f.querySelector('input[name="id"]');
    if (inp && mode.kind === 'hod') {
      if (!swap || String(inp.value) !== String(swap.alt)) swap = { orig: String(mode.orig || inp.value), alt: String(mode.vid) };
      inp.value = mode.vid;
    } else if (inp && swap && String(inp.value) === String(swap.alt)) {
      inp.value = swap.orig; swap = null;
    }
    addButtons().forEach(function (b) {
      if (!b.dataset.tyfrHtml) { b.dataset.tyfrHtml = b.innerHTML; b.dataset.tyfrDis = b.disabled ? '1' : ''; b.dataset.tyfrVid = String(mode.orig || ''); }
      b.disabled = false; b.removeAttribute('aria-disabled');
      b.classList.add('tyfr-buy');
      var label = mode.kind === 'eilat' ? 'לשריון באילת' : 'הוסף לעגלה';
      var span = b.querySelector('span:not(.loading__spinner):not(.visually-hidden)');
      if (span) span.textContent = label; else b.textContent = label;
    });
    var sb = document.getElementById('StickyBuyBarBtn'), sp = document.getElementById('StickyBuyBarPrice');
    if (sb) {
      if (sb.dataset.tyfrHtml == null) { sb.dataset.tyfrHtml = sb.innerHTML; sb.dataset.tyfrCls = sb.className; sb.dataset.tyfrDis = sb.disabled ? '1' : ''; }
      sb.textContent = mode.kind === 'eilat' ? 'לשריון באילת' : 'הוסף לעגלה';
      sb.disabled = false; sb.removeAttribute('aria-disabled'); sb.classList.add('tyfr-buy');
    }
    [sp, document.querySelector('.sticky-cta__price')].forEach(function (el) {
      if (el && mode.price) { if (el.dataset.tyfrHtml == null) el.dataset.tyfrHtml = el.innerHTML; el.textContent = mode.price; }
    });
  }
  /* nowVid: הגרסה שנבחרה עכשיו. אם היא אחרת מזו שעליה החלפנו, הערכה כבר
     עדכנה את הכפתור הראשי לגרסה החדשה, ואסור להחזיר אליו את המצב הישן. */
  function clearBuy(nowVid) {
    var f = productForm(), inp = f && f.querySelector('input[name="id"]');
    if (inp && swap && String(inp.value) === String(swap.alt)) inp.value = nowVid || swap.orig;
    swap = null;
    if (!buyMode) return;
    buyMode = null;
    addButtons().forEach(function (b) {
      b.classList.remove('tyfr-buy');
      if (b.dataset.tyfrHtml != null) {
        if (String(b.dataset.tyfrVid) === String(nowVid)) { b.innerHTML = b.dataset.tyfrHtml; b.disabled = !!b.dataset.tyfrDis; }
        delete b.dataset.tyfrHtml; delete b.dataset.tyfrDis; delete b.dataset.tyfrVid;
      }
    });
    var sb = document.getElementById('StickyBuyBarBtn'), sp = document.getElementById('StickyBuyBarPrice');
    if (sb && sb.dataset.tyfrHtml != null) { sb.innerHTML = sb.dataset.tyfrHtml; sb.className = sb.dataset.tyfrCls; sb.disabled = !!sb.dataset.tyfrDis; delete sb.dataset.tyfrHtml; delete sb.dataset.tyfrCls; delete sb.dataset.tyfrDis; }
    [sp, document.querySelector('.sticky-cta__price')].forEach(function (el) {
      if (el && el.dataset.tyfrHtml != null) { el.innerHTML = el.dataset.tyfrHtml; delete el.dataset.tyfrHtml; }
    });
  }
  document.addEventListener('click', function (e) {
    if (!buyMode) return;
    var sticky = e.target.closest && e.target.closest('#StickyBuyBarBtn');
    var main = e.target.closest && e.target.closest('button[name="add"]');
    if (buyMode.kind === 'eilat' && (sticky || main)) {
      e.preventDefault(); e.stopImmediatePropagation();
      location.href = buyMode.url; return;
    }
    /* הפס הדביק בטלפון לא נרשם ללחיצות כשהדף נטען על גרסה שאזלה. כאן הוא לוחץ על הכפתור האמיתי. */
    if (sticky) {
      e.preventDefault(); e.stopImmediatePropagation();
      var real = document.querySelector('product-form button[name="add"]');
      if (real && !real.disabled) { real.scrollIntoView({ block: 'center', behavior: 'smooth' }); real.click(); }
    }
  }, true);

  /* ---------- הרכבה ---------- */
  function cube(o) {
    return '<div class="tybp__cube tyfr__cube' + (o.out ? ' is-out' : '') + '" role="radio" tabindex="0" aria-checked="false" data-kind="' + o.kind + '">' +
      '<span class="tybp__radio" aria-hidden="true"></span>' +
      '<span class="tybp__txt"><span class="tybp__name">' + esc(o.branch) + '<span class="tyfr__chip">' + esc(o.chip) + '</span></span>' +
      '<span class="tybp__meta"><i class="tybp__dot' + (o.out ? '' : ' tyfr__in') + '" aria-hidden="true"></i>' +
      '<span class="tybp__stock">' + (o.out ? 'אזל מהמלאי' : 'במלאי') + '</span><span class="tybp__sep" aria-hidden="true">·</span>' + esc(o.method) + '</span></span>' +
      '<span class="tybp__price">' + esc(o.price) + '</span></div>';
  }

  var seq = 0;
  function run() {
    var my = ++seq;
    var host = document.querySelector('[id^="ty-branch-"]');
    var tybp = host && host.querySelector('.tybp');
    if (!tybp) return;
    var h = currentHandle(); if (!h) return;
    var eilatPage = /-eilat$/.test(h);
    if (eilatPage) return; // דפי אילת: בלי שינוי בסבב הזה
    /* ty-flavor-404b >>> */
    /* tps-09, 14.10.2026: גרסאות אחיות קיימות רק לטלפונים. אביזר לא שולח אף בקשה. */
    var tyType = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.type) || '';
    if (tyType && tyType !== 'phones') return;
    /* <<< ty-flavor-404b */
    var hodH = h, curF = FLAVORS[0];
    FLAVORS.forEach(function (f) { if (f.sfx && hodH.slice(-f.sfx.length) === f.sfx) curF = f; });
    var base = curF.sfx ? hodH.slice(0, -curF.sfx.length) : hodH;
    var fam = FLAVORS.map(function (f) { return { f: f, hod: base + f.sfx, eilat: base + f.sfx + '-eilat' }; });
    var handles = []; fam.forEach(function (x) { handles.push(x.hod, x.eilat); });

    Promise.all(handles.map(getProduct)).then(function (ps) {
      if (my !== seq) return;
      var P = {}; handles.forEach(function (hh, i) { P[hh] = ps[i]; });
      var cur = P[hodH]; if (!cur) return;
      var vid = currentVariantId(cur);
      var v = cur.variants.find(function (x) { return String(x.id) === String(vid); }) || cur.variants[0];
      var c = comboOf(cur, v);
      var curRow = fam.find(function (x) { return x.f === curF; });
      var cH = pick(P[curRow.hod], c.size, c.color), cE = pick(P[curRow.eilat], c.size, c.color);
      reset(host, v.id);
      if ((cH && cH.available) || (cE && cE.available)) return; // יש בגרסה הזו: הקוביות הרגילות

      var alt = null;
      // סדר ההעדפה, הכרעת יובל 01.10.2026: eSIM בלבד, אחריו הייבוא שלנו, אחריו יבואן רשמי.
      ['esim', 'regular', 'official'].map(function (id) { return fam.find(function (x) { return x.f.id === id; }); }).forEach(function (x) {
        if (!x || alt || x.f === curF) return;
        var aH = pick(P[x.hod], c.size, c.color), aE = pick(P[x.eilat], c.size, c.color);
        if ((aH && aH.available) || (aE && aE.available)) alt = { x: x, h: aH, e: aE };
      });
      /* «עדכנו אותי» רק ב-iPhone 18 Pro ו-Pro Max, בשלוש הגרסאות, ב-256GB · 512GB · 1TB. הכרעת יובל 02.10.2026.
         מחוץ לזה: מצב א מציג את הגרסה האחרת בלי שורת העדכון, ומצב ב אינו מוצג בכלל (הקוביות הרגילות נשארות). */
      var canNotify = NOTIFY_MODELS.indexOf(base) >= 0 && NOTIFY_SIZES.indexOf(c.size) >= 0;
      if (!alt && !canNotify) return;
      var label = esc(c.size) + (c.color ? ' ' + esc(c.color) : '');
      var box = document.createElement('div');
      box.className = 'tyfr';
      tybp.parentNode.insertBefore(box, tybp);
      host.classList.add('tyfr-on');
      document.documentElement.classList.add('tyfr-b'); // משפט ה-Active New יורד בשני המצבים

      if (alt) {
        var sel = tybp.dataset.sel === 'eilat' ? 'eilat' : 'hod';
        if (sel === 'hod' && !(alt.h && alt.h.available)) sel = 'eilat';
        if (sel === 'eilat' && !(alt.e && alt.e.available)) sel = 'hod';
        var altF = txt(alt.x.f, curF), curT = txt(curF, alt.x.f);
        var altUrl = '/products/' + alt.x.hod + (alt.h ? '?variant=' + alt.h.v.id : '');
        box.innerHTML =
          '<p class="tyfr__msg"><span class="tyfr__dot" aria-hidden="true"></span>' + label + ' <span class="tyfr__red">אזל</span> ' + curT.phrase + '</p>' +
          '<p class="tyfr__sub">יש אותו ' + altF.phrase + (altF.desc ? ', ' + altF.desc : '') + '.</p>' +
          '<div class="tybp tyfr__cubes" role="radiogroup" aria-label="בחירת סניף, ' + esc(altF.the) + '">' +
            (alt.h ? cube({ kind: 'hod', branch: 'הוד השרון', chip: altF.name, method: 'משלוח או איסוף', price: money(alt.h.v.price), out: !alt.h.available }) : '') +
            (alt.e ? cube({ kind: 'eilat', branch: 'אילת', chip: altF.name, method: 'איסוף עצמי', price: money(alt.e.v.price), out: !alt.e.available }) : '') +
          '</div>' +
          '<p class="tyfr__alt"><a href="' + altUrl + '">לדף המוצר של ' + esc(altF.the) + CHEV + '</a></p>' +
          (canNotify ? '<div class="tyfr__nt"><div><b>מעדיפים את ' + curT.the + '?</b><small>נעדכן אותך כשתחזור למלאי</small></div>' +
          '<button type="button" class="tyfr__ob"><span class="tyfr__bell" aria-hidden="true">🔔</span><span>עדכנו אותי</span></button></div>' : '');
        var choose = function (kind) {
          box.querySelectorAll('.tyfr__cube').forEach(function (el) {
            var on = el.dataset.kind === kind;
            el.classList.toggle('tyfr__sel', on); el.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          if (kind === 'hod') setBuy({ kind: 'hod', orig: v.id, vid: alt.h.v.id, price: money(alt.h.v.price) });
          else setBuy({ kind: 'eilat', orig: v.id, url: '/products/' + alt.x.eilat + '?variant=' + alt.e.v.id, price: money(alt.e.v.price) });
        };
        box.querySelectorAll('.tyfr__cube').forEach(function (el) {
          if (el.classList.contains('is-out')) return;
          el.addEventListener('click', function () { choose(el.dataset.kind); });
          el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(el.dataset.kind); } });
        });
        choose(sel);
        if (canNotify) box.querySelector('.tyfr__nt .tyfr__ob').addEventListener('click', function () {
          var nt = box.querySelector('.tyfr__nt');
          var wrap = document.createElement('div');
          wrap.className = 'tyfr__box tyfr__box--x';
          wrap.innerHTML = '<button type="button" class="tyfr__x" aria-label="סגירה">' + XICON + '</button>' + formHtml({ title: 'נעדכן אותך כש' + curT.the + ' חוזרת', sub: label + '. השאירו שם וטלפון, ונשלח לכם הודעה.' });
          nt.replaceWith(wrap);
          wireForm(wrap.querySelector('form'), { product: cur, variant: v });
          /* בלי focus על שדה: באייפון הוא פותח מקלדת והדף קופץ (יובל, 02.10.2026). המקלדת נפתחת רק בלחיצה על שדה.
             הפוקוס עובר לתיבה עצמה, לקורא מסך, ונגלל רק אם התיבה אינה במסך. */
          wrap.setAttribute('tabindex', '-1'); wrap.focus({ preventScroll: true });
          var rb = wrap.getBoundingClientRect();
          if (rb.bottom > window.innerHeight || rb.top < 0) wrap.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          wrap.querySelector('.tyfr__x').addEventListener('click', function () { wrap.replaceWith(nt); nt.querySelector('.tyfr__ob').focus({ preventScroll: true }); });
        });
      } else {
        var whole = !Object.keys(P).some(function (hh) {
          return P[hh] && matchVariants(P[hh], c.size, null).some(function (x) { return x.available; });
        });
        var model = (P[base] && P[base].title) || cur.title;
        document.documentElement.classList.add('tyfr-b');
        box.innerHTML = '<div class="tyfr__box">' + formHtml({
          title: esc(model) + ' ' + esc(c.size) + (whole || !c.color ? '' : ' ' + esc(c.color)) + ' <span class="tyfr__red">אזל מהמלאי</span>',
          sub: 'השאירו שם וטלפון, ונשלח לכם הודעה כשיחזור.',
          anyColor: whole && c.color ? 'גם אם יחזור בצבע אחר ב-' + esc(c.size) : ''
        }) + '</div>';
        wireForm(box.querySelector('form'), { product: cur, variant: v });
      }
    });
  }

  function reset(host, nowVid) {
    clearBuy(nowVid);
    document.documentElement.classList.remove('tyfr-b');
    if (!host) return;
    host.classList.remove('tyfr-on');
    host.querySelectorAll('.tyfr').forEach(function (el) { el.remove(); });
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(run, 80); }
  function observe() {
    var host = document.querySelector('[id^="ty-branch-"]');
    if (!host || host.__tyfrObs) return;
    host.__tyfrObs = true;
    new MutationObserver(function (muts) {
      // שינוי שאנחנו עשינו אינו סיבה לרוץ שוב.
      var isOurs = function (n) { return n.nodeType !== 1 || (n.classList && n.classList.contains('tyfr')); };
      var ours = muts.every(function (m) {
        if (m.target.closest && m.target.closest('.tyfr')) return true;
        return Array.prototype.every.call(m.addedNodes, isOurs) && Array.prototype.every.call(m.removedNodes, isOurs);
      });
      if (!ours) schedule();
    }).observe(host, { childList: true, subtree: true });
  }
  function boot() { observe(); run(); }
  document.addEventListener('variant:change', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
